/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendRightUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M207.39062,83.06152A8,8,0,0,1,200,88H160v40A104.11791,104.11791,0,0,1,56,232a8,8,0,0,1,0-16,88.09957,88.09957,0,0,0,88-88V88H104a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00028,8.00028,0,0,1,207.39062,83.06152Z" />
    </Svg>
  );
}

export default ArrowBendRightUp;
